import { apiClient } from '../../../v4/core/apiClient';
import { queryClient } from '../../../v4/migration/queryClientSingleton';
import { createGlobalSearchApi } from '../../api/global-search/global-search.api.http';
import { globalSearchRecentsByScope$ } from '../../api/global-search/global-search.api.ls.schema';
import { createLocalStorageApi } from '../../platform/ts/localStorageApi';
import { createGlobalSearchService } from './GlobalSearchService.impl';
import { myErrorService } from '../front/ErrorService/ErrorService.connected';

export const myGlobalSearchService = createGlobalSearchService({
  api: createGlobalSearchApi(apiClient),
  recentsApi: createLocalStorageApi(
    'global-search-recents',
    globalSearchRecentsByScope$.parse,
    {}
  ),
  queryClient,
  services: { errorService: myErrorService }
});
